<template>
  <div
    v-if="values && values.length > 0"
    class="tech-details__row lg:pr-8 lg:w-1/3"
  >
    <div class="tech-details__row__content w-full h-full px-2 py-2.5 flex gap-3">
      <div class="tech-details__label w-3/5 font-bold">
        {{ label }}
      </div>
      <div class="w-2/5">
        <div
          v-for="(detail, index) in values"
          :key="index"
        >
          <div
            v-if="isPlainObject(detail)"
            class="tech-details__value"
          >
            <span class="font-medium">{{ detail.key }}</span>
            <div
              v-for="(item, i) in detail.values"
              :key="i"
            >
              {{ item }}
            </div>
          </div>
          <span v-else>{{ detail }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">

import type { PropType } from 'vue';

export default defineComponent({
  name: 'TechnicalDetail',
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Array as PropType<string[]>,
      default: () => {

        return [];
      
      },
    },
  },
  setup() {

    const isPlainObject = (input) => {

      return input && !Array.isArray(input) && typeof input === 'object';
    
    };

    return {
      isPlainObject,
    };
  
  },
});

</script>
<style scoped lang="scss">
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
.tech-details {
  &__row {
    // adding background only in the odd rows based on flex-wrap
    @include breakpoints.for-desktop {
      &:nth-child(1) &__content,
      &:nth-child(2) &__content,
      &:nth-child(3) &__content,
      &:nth-child(6n + 1) &__content,
      &:nth-child(6n + 2) &__content,
      &:nth-child(6n + 3) &__content {
        @apply bg-EXPONDO-primary-5;
      }
    }

    @include breakpoints.for-mobile {
      &:nth-child(odd) &__content {
        @apply bg-EXPONDO-primary-5;
      }
    }
  }
}
</style>
